<template>
<div>
    <div style="border: 1px solid rgba(0, 0, 0, 0.1); border-radius: 5px; padding: 35px;">
        <h2 style="text-align: center; color: rgb(243, 112, 67); margin: 0px 0px 10px; font-weight: 400;"><em class="far fa-life-ring"></em></h2>
        <h4 class="text-center">Want to pass on your feedback, thoughts or concerns?</h4>
        
        <div class="petition-form wwf-form light" :class="{ 'hide' : step1 }">
            <div class="flip-wrapper" :class="{ 'formValidation-shake' : isShake }">
                <div class="petition-form">
                <input name="emailAddress" type="email" v-model="emailAddress" v-validate="'required|email'" :class="{'border-red': errors.has('emailAddress')}" placeholder="Email Address">
                <input name="subject" type="text" v-model="subject" v-validate="'required'" :class="{'border-red': errors.has('subject')}" placeholder="Subject">
                <input name="phone" type="text" v-model="phone" v-validate="'required'" :class="{'border-red': errors.has('phone')}" placeholder="Phone">
                <textarea  name="message" type="text" v-model="message" v-validate="'required'" :class="{'border-red': errors.has('message')}" placeholder="Message" class=""></textarea>
        
                <input type="button" v-on:click="postTicket" value="Submit" />
                </div>
            </div>
        </div>
        <div :class="{ 'hide' : step2 }">
            <p>Your message has been received by our team and we will respond as soon as possible</p>
        </div>

        <p class="text-center show-for-large">WWF-Australia takes all complaints and feedback seriously. For information
            about our Complaint Handling Process, please <a href="/ArticleDocuments/391/doc-policy-wwfaus-complaint-handling-jul18.pdf.aspx"
                target="_blank" class="document pdf">click here<span class="file-info">&nbsp;(<span class="file-type">PDF</span>&nbsp;<span
                        class="file-size">380.6KB</span>)</span></a>.</p>
        <p class="text-center hide-for-large">Please tap on the orange question mark on the bottom-right of your screen</p>
    </div>
</div>
    
</template>

<script>
export default {
    name: 'contactUs',
    data() {
        return {
            isShake: false,
            step1: false,
            step2: true,
            emailAddress: "",
            subject: "",
            phone: "",
            message: "",
            isLoading: false
        };
    },
    methods: {
        postTicket: function () {
            this.$validator.validateAll().then(result => { 
                if(result){
                    this.step1 = true
                    this.step2 = false
                    this.$http.post('https://us-central1-fire-panda.cloudfunctions.net/zendeskCreateTicket', {
                        emailAddress: this.emailAddress,
                        subject: this.subject,
                        phone: this.phone,
                        message: this.message
                    }).then(response => {
                        console.log(response)
                    }, error => {
                        console.error(error)
                    })
                }
                else {
                    console.log("form invalid");
                    this.isShake = true;
                    setTimeout(
                        function() {
                        this.isShake = false;
                        }.bind(this),
                        500
                    );
                }
            })
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// contactUs.vue?ed3b489e